import { render, staticRenderFns } from "./LibraryCategories.vue?vue&type=template&id=cc8bd3ec"
import script from "./LibraryCategories.vue?vue&type=script&lang=ts"
export * from "./LibraryCategories.vue?vue&type=script&lang=ts"
import style0 from "./LibraryCategories.vue?vue&type=style&index=0&id=cc8bd3ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports